import { http } from '../config/http.config.js';

/**
 * Fetch wrapper
 *
 * @param {string} url Target endpoint
 * @param {object} options HTTP parameters { method, body, query }
 *
 * @returns Promise<any>
 */
const useFetch = async (url, options) => {
  const SUCCESS = [200, 201, 204];
  const parameters = {
    ...{ method: options.method },
    ...http.config,
  };

  if (['POST', 'PUT', 'PATCH'].includes(options.method)) {
    parameters.body = JSON.stringify(options.body);
  }

  // eslint-disable-next-line no-undef
  const response = await fetch(`${http.api.path}${url}${options.query ? `?${new URLSearchParams(options.query)}` : ''}`, parameters).catch(e => e);

  if (!SUCCESS.includes(response.status)) {
    const error = await response.json().catch(e => e);
    if (error?.detail) {
      throw new Error(error.detail);
    }
    return;
  }

  return response.json();
};

export { useFetch };
